import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

type ThumbnailViewItemsType = {
  thumbnailId: number;
  thumbnail: string;
};

export type DecryptedThumbnailItemsState = {
  thumbnails: ThumbnailViewItemsType[];
};

const initialState: DecryptedThumbnailItemsState = {
  thumbnails: []
};

const DecryptedThumbnailItems = createSlice({
  name: 'thumbnailItems',
  initialState: initialState,
  reducers: {
    addDecryptedThumbnailItem(state, action) {
      if (!state.thumbnails.some((thumbnail) => thumbnail.thumbnailId === action.payload.thumbnailId)) {
        state.thumbnails.push(action.payload);
      }
    }
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selectThumbnailById = (state: RootState, thumbnailId: number) =>
  state.decryptedThumbnailItems.thumbnails.find(
    (thumbnail: ThumbnailViewItemsType) => thumbnail.thumbnailId === thumbnailId
  ) || null;

export const { addDecryptedThumbnailItem } = DecryptedThumbnailItems.actions;
export const DecryptedThumbnailItemsReducer = DecryptedThumbnailItems.reducer;
